import { render, staticRenderFns } from "./ToggleArrowButton.vue?vue&type=template&id=4c47f974&scoped=true"
import script from "./ToggleArrowButton.vue?vue&type=script&lang=js"
export * from "./ToggleArrowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47f974",
  null
  
)

export default component.exports